import type { FC } from 'react';

import type { LinkProps } from '@remix-run/react';
import { Link } from '@remix-run/react';
import cn from 'classnames';

import { GLASS_CLASSES } from './_styles/glass';

type GlassIconLinkProps = LinkProps & {
  'aria-label': string;
  className?: string;
};

export const GlassIconLink: FC<GlassIconLinkProps> = ({ className, children, ...props }) => {
  return (
    <Link className={cn(GLASS_CLASSES, className)} {...props}>
      {children}
    </Link>
  );
};
